let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("h0Fuu")).then(() => parcelRequire('fTEZ5'));